import {ReactElement, useState} from "react"
import {MenuItemProps} from "../menu"
import Main from "./Main"
import BoatInfo from "./boat"
import Captain from "./Captain"
import {ProfilePage, TProfilePageProps} from "./common"

const Profile  = ({isShow, close}: MenuItemProps): ReactElement => {
  const [page, setPage] = useState<ProfilePage>(ProfilePage.Main)

  const props: TProfilePageProps = {page, setPage, close, isShow}

  const getPage = (): ReactElement => {
    switch(page) {
      case ProfilePage.Main:
        return <Main {...props} />
      case ProfilePage.Captain:
        return <Captain {...props} />
      case ProfilePage.Common:
      case ProfilePage.Dimensions:
      case ProfilePage.Tracking:
        return <BoatInfo {...props} />
      default:
        return <></>
    }
  }

  return (
    <div className="profile">
      {getPage()}
    </div>
  )
}

export default Profile
